import React from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#0a0a0a",
            padding: "24px",
          }}
        >
          <div
            style={{
              maxWidth: "480px",
              width: "100%",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <AlertTriangle size={48} color="#f59e0b" />
            </div>
            <h1
              style={{
                color: "#ffffff",
                fontSize: "24px",
                fontWeight: "700",
                marginBottom: "8px",
              }}
            >
              เกิดข้อผิดพลาด
            </h1>
            <p style={{ color: "#9ca3af", fontSize: "14px", marginBottom: "24px" }}>
              แอปเกิดข้อผิดพลาดที่ไม่คาดคิด กรุณาโหลดหน้าใหม่
            </p>

            {this.state.error && (
              <pre
                style={{
                  background: "#1a1a1a",
                  border: "1px solid #2d2d2d",
                  borderRadius: "8px",
                  padding: "12px",
                  fontSize: "11px",
                  color: "#ef4444",
                  textAlign: "left",
                  overflowX: "auto",
                  marginBottom: "24px",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {this.state.error.toString()}
              </pre>
            )}

            <button
              onClick={() => window.location.reload()}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 24px",
                backgroundColor: "#BFFF00",
                color: "#000000",
                border: "none",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              <RefreshCw size={16} />
              โหลดหน้าใหม่
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
